import React from "react";
import NavbarHeader from "../Navbar";
import FooterBfsg from "../FooterBfsg";
import main from "../../Image/B2B-Website-UI/AugustinusBader-main.jpg";
import Logo from "../../Image/B2B-Website-UI/AugustinusBader-logo.png";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Product01 from "../../Image/Top-Products/AugustinusBader/TheRichCream.jpg";
import Product02 from "../../Image/Top-Products/AugustinusBader/TheCream.jpg";
import Product03 from "../../Image/Top-Products/AugustinusBader/TheCreamCleansingGel.jpg";
import Product04 from "../../Image/Top-Products/AugustinusBader/TheEssence.jpg";
import Product05 from "../../Image/Top-Products/AugustinusBader/TheEyePatches.jpg";

const AugustinusBader = () => {
  const options = {
    loop: true,
    margin: 50,
    nav: true,
    dots: false,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" width="42" height="13" viewBox="0 0 42 13" fill="none">' +
        '<path d="M0.357289 6.71437L9.62174 12.273C10.155 12.593 10.8333 12.2089 10.8333 11.587L10.8333 1.41296C10.8333 0.79112 10.155 0.407029 9.62174 0.72696L0.357289 6.28563C0.195455 6.38273 0.195455 6.61727 0.357289 6.71437Z" fill="#7F7F7F"/>' +
        '<path d="M10.8333 6.5L41.1667 6.5" stroke="#7F7F7F" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg>",
      '<svg xmlns="http://www.w3.org/2000/svg" width="43" height="13" viewBox="0 0 43 13" fill="none">' +
        '<path d="M41.8093 6.28563L32.5449 0.726957C32.0117 0.407025 31.3333 0.791116 31.3333 1.41295L31.3333 11.587C31.3333 12.2089 32.0117 12.593 32.5449 12.273L41.8093 6.71437C41.9712 6.61727 41.9712 6.38273 41.8093 6.28563Z" fill="#7F7F7F"/>' +
        '<path d="M31.3333 6.5L0.999975 6.5" stroke="#7F7F7F" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg>",
    ],
    responsive: {
      0: {
        items: 1,
      },
      767: {
        items: 2,
      },
      1000: {
        items: 3,
      },
    },
  };
  return (
    <div>
      <NavbarHeader />
      <section>
        <div className="container">
          <div className="mt-5"></div>
          <div className="row">
            <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 m-auto">
              <div className="BnadLogo w-100">
                <img className="img-fluid" src={main} />
              </div>
            </div>
            <div className="col-xl-8 col-lg-8 col-md-12 col-sm-12 m-auto ">
              <div className="row">
                <div className="col-xl-7 col-lg-6 col-md-12 col-sm-12 borderRight">
                  <img className="img-fluid heightWidth" src={Logo} />
                </div>
                <div className="col-xl-5 col-lg-6 col-md-12 col-sm-12 m-auto ">
                  <h1 className="titleWithLogo">Revolutionary Science. Biological Wisdom.</h1>
                </div>
              </div>
              <div className="autoHeight" id="ScrollRight">
                <p className="seti">
                  A world-renowned physician and one of the foremost experts in
                  the field of stem cell science and regenerative medicine,
                  Professor Bader has spent over thirty years developing
                  technologies that stimulate and harness the human body's innate
                  self-healing processes. In 2008, he developed a revolutionary
                  medical Wound Gel that can repair burns and skin lesions by
                  reactivating cells whose activity has been inhibited by aging
                  or traumatic injury, enabling patients to avoid surgery or skin
                  grafts.
                </p>

                <p className="seti">
                  Building on his decades of research and deep understanding of
                  the body's healing capabilities, Professor Bader developed
                  TFC8&reg;, a proprietary, highly sophisticated cosmetic
                  technology proven to dramatically improve the appearance of
                  wrinkles, redness, blemishes, dryness, photoaging damage,
                  pores, and more across all skin types.
                </p>
              </div>
            </div>
          </div>

          <div className="TopProducts NewArriavalsList">
            <h3 className="mt-5">TOP PRODUCTS</h3>
            <OwlCarousel className="owl-theme" {...options}>
              <div className="item">
                <div>
                  <div className="ArriavalsInnerContent">
                    <h4>The Rich Cream</h4>
                    <p>
                      A deeply nourishing moisturizer powered by TFC8&reg; that renews and restores for visibly healthier, more radiant skin.
                    </p>
                    <a href="https://b2b.beautyfashionsales.com/">
                      Shop The Collection
                    </a>
                    <div className="fitContent">
                      <img src={Product01} alt="The Rich Cream" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div>
                  <div className="ArriavalsInnerContent">
                    <h4>The Cream</h4>
                    <p>
                      A lightweight yet powerful moisturizer with TFC8&reg; that hydrates, firms and revitalizes all skin types.
                    </p>
                    <a href="https://b2b.beautyfashionsales.com/">
                      Shop The Collection
                    </a>
                    <div className="fitContent">
                      <img src={Product02} alt="The Cream" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div>
                  <div className="ArriavalsInnerContent">
                    <h4>The Cream Cleansing Gel</h4>
                    <p>
                      A gentle, pH-balanced cleansing gel infused with TFC8&reg; that purifies without stripping the skin.
                    </p>
                    <a href="https://b2b.beautyfashionsales.com/">
                      Shop The Collection
                    </a>
                    <div className="fitContent">
                      <img src={Product03} alt="The Cream Cleansing Gel" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div>
                  <div className="ArriavalsInnerContent">
                    <h4>The Essence</h4>
                    <p>
                      A concentrated treatment essence with TFC8&reg; that primes skin for optimal absorption of subsequent products.
                    </p>
                    <a href="https://b2b.beautyfashionsales.com/">
                      Shop The Collection
                    </a>
                    <div className="fitContent">
                      <img src={Product04} alt="The Essence" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="item">
                <div>
                  <div className="ArriavalsInnerContent">
                    <h4>The Eye Patches</h4>
                    <p>
                      Hydrogel eye patches infused with TFC8&reg; that visibly brighten, smooth and depuff the delicate eye area.
                    </p>
                    <a href="https://b2b.beautyfashionsales.com/">
                      Shop The Collection
                    </a>
                    <div className="fitContent">
                      <img src={Product05} alt="The Eye Patches" />
                    </div>
                  </div>
                </div>
              </div>
            </OwlCarousel>
          </div>
        </div>
      </section>
      <FooterBfsg />
    </div>
  );
};

export default AugustinusBader;
